import * as React from "react";
import { useHistory } from "react-router-dom";

import {
  Context,
  clearSuccessMessage,
  resetTeacherPassword,
  RESET_TEACHER_PASSWORD_SUCCESS_MESSAGE,
  resetPasswordCompletedPath,
} from "../../../teacherStore";
import ForgotPassword from "../../../templates/teacher/ForgotPassword";

export default () => {
  const { state, dispatch } = React.useContext(Context);
  const history = useHistory();

  React.useEffect(() => {
    if (state.success_message === RESET_TEACHER_PASSWORD_SUCCESS_MESSAGE) {
      dispatch(clearSuccessMessage());
      history.push(resetPasswordCompletedPath);
    }
  }, [history, dispatch, state.success_message]);

  const forgotPasswordFunc = React.useCallback(
    (email: string) => {
      dispatch(resetTeacherPassword(email));
    },
    [dispatch],
  );

  return (
    <ForgotPassword forgotPassword={forgotPasswordFunc} error={state.error} />
  );
};
